import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";

// Get URL query parameters
const params = new URLSearchParams( window.location.search );
const error  = params.get( "login_error" );

// Check if there is an error and if the user is blocked
if ( error === "user_blocked" ) {
	Toastify({
		text: psh_vars.user_blocked_message,
		duration: 10000,
		close: true,
		position: "right",
		backgroundColor: "#e74c3c",
		offset: {
			y: 75,
		}
	}).showToast();
}